import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const state = {
    userLoged: {},
    pendingHttpRequests: [],
    lastModifiedExam: false
}

function removeTimedoutRequests(requests) {
  // BUG FIX 
  // Removes pending HTTP requests that have timedout (occurs when page if closed before the request is finished, 
  //                                                   than it's not removed from the list of pending requests)  
  return requests.filter(function (request) {        
    let timeout = typeof request.timeout !== 'undefined' && request.timeout > 0 ? request.timeout : 30000,
        currTime = new Date().getTime()
    return currTime <= request.beginTime + timeout
  })
}

const mutations = {
  addHttpRequest (state, request) {
    state.pendingHttpRequests = removeTimedoutRequests(state.pendingHttpRequests)
    request.beginTime = new Date().getTime()
    state.pendingHttpRequests.push(request)    
  },
  removeHttpRequest (state, request) {
    state.pendingHttpRequests.remove(request)
  },
  setLastModifiedExam (state, exam) {
    // state.lastModifiedExam = exam;
    state.lastModifiedExam = false;
  }
}

const getters = {
    showFullscreenLoadingSpinner: function (state) {
      let pendingHttpRequests = removeTimedoutRequests(state.pendingHttpRequests)
      return pendingHttpRequests.filter(function (request) {
        return typeof request.hideFullscreenLoadingSpinner === 'undefined' || request.hideFullscreenLoadingSpinner == false
      }).length > 0
    }
}

export default new Vuex.Store({
    state,
    getters,
    // actions,
    mutations,
    plugins: [createPersistedState()]
})


// WEBPACK FOOTER //
// ./src/store.js